const getApiUrl = () => process.env.REACT_APP_URL_PROD_MEDAM;
// process.env.REACT_APP_PROD_MEDAM || process.env.REACT_APP_URL_PROD_MEDAM;

export const getInsuranceCompaniesFromApi = async () => {
  const baseUrl = (getApiUrl() || "").replace(/\/+$/, "");

  if (!baseUrl) {
    return [];
  }

  try {
    const response = await fetch(
      `${baseUrl}/agreement/getAgreementsByCategory/Aseguradoras`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    const payload = await response.json();

    if (Array.isArray(payload)) {
      return payload.map((item) => ({
        id: item.folio,
        name: item.nombre_razon_social,
        ranking: item.ranking,
        imagen: item.imagen,
      }));
    }

    if (Array.isArray(payload?.data)) {
      return payload.data.map((item) => ({
        id: item.folio,
        name: item.nombre_razon_social,
        ranking: item.ranking,
        imagen: item.imagen,
      }));
    }

    return [];
  } catch (error) {
    console.error("No se pudieron cargar las aseguradoras:", error);
    return [];
  }
};
